// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1237":"130983b3","9355":"78e77278"}[chunkId] + ".css";
};